const API_BASE = import.meta.env.VITE_API_URL ?? ''

function getLang(): string {
  if (typeof window === 'undefined') return 'sk'
  const params = new URLSearchParams(window.location.search)
  const lang = params.get('lang') ?? navigator.language?.slice(0, 2) ?? 'sk'
  return ['sk', 'en', 'cs'].includes(lang) ? lang : 'sk'
}

async function request<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const url = path.startsWith('http') ? path : `${API_BASE.replace(/\/$/, '')}${path}`
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Accept-Language': getLang(),
    ...(options.headers ?? {}),
  }
  const res = await fetch(url, { ...options, headers })
  if (!res.ok) {
    const text = await res.text()
    throw new Error(`API ${res.status}: ${text || res.statusText}`)
  }
  if (res.status === 204) return undefined as T
  return res.json() as Promise<T>
}

export async function apiGet<T>(path: string, params?: Record<string, string | number | undefined>): Promise<T> {
  const search = params
    ? '?' +
      Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
        .join('&')
    : ''
  return request<T>(path + search, { method: 'GET' })
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  return request<T>(path, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export { API_BASE }
